import * as React from "react";
import type { SVGProps } from "react";
export const SvgYearInReviewTriple = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 24 24" {...props}>
    <g clipPath="url(#year-in-review-triple_svg__a)">
      <path fill="currentColor" d="M12 4.64 20.868 20H3.132L12 4.64Z" />
    </g>
    <defs>
      <clipPath id="year-in-review-triple_svg__a">
        <path fill="#fff" d="M3.2 4.8h17.6V20H3.2z" />
      </clipPath>
    </defs>
  </svg>
);
